<template>
  <div style="border: 1px solid #dedede;width: 95%;margin: 0 auto; display: block;">
    <div style="margin-left: 10px;color: #939393">序列号</div>
    <frame-form ref="after_sales_sn_general" component-param="after_sales_sn_general" :readonly="isDisable" ></frame-form>
  </div>

  <div style="border: 1px solid #dedede;width: 95%;display: block;margin: 10px auto 0;">
    <div style="margin-left: 10px;color: #939393">产品明细</div>
    <frame-form  ref="crm_asset_product_manage" :readonly="isDisable"
                 style="padding-left: 100px" component-param="crm_asset_product_manage"></frame-form>
  </div>

  <div style="border: 1px solid #dedede;width: 95%;display: block;margin: 10px auto 0;">
    <div style="margin-left: 10px;color: #939393">关联信息</div>
    <el-form>
      <el-row>
        <el-col :span="11">
          <el-form-item label="机会编号：" label-position="right" label-width="150px" required>
            <el-select v-model="chance_id" @change="getContractList" :disabled="isDisable">
              <el-option v-for="item in chanceList" :key="item.id" :label="item.id" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="合同编号：" label-position="right" label-width="150px">
            <el-select v-model="contract_no" :disabled="isDisable" clearable>
              <el-option v-for="item in contractList" :key="item.contract_no" :label="item.contract_no" :value="item.contract_no"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="22">
          <el-form-item label="备注：" label-position="right" label-width="150px">
            <el-input style="width: 100%" v-model="remark" :disabled="isDisable" type="textarea" rows="3" ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
  <div v-if="!isDisable" style="margin: 10px 0 50px 0;text-align: center">
    <el-button type="primary" style="width: 150px" @click="saveData" >保存</el-button>
  </div>

</template>

<script>
export default {
  name: "AddSnOperate",
  inject: ['$fn'],

  props: {
    companyId: {
      type: String,
      required: true
    },
    isDisable:{
      type: Boolean,
      required: true
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  data() {
    return {
      chanceList:[],
      contractList:[],
      chance_id:'',
      contract_no:'',
      remark:'',
    }
  },

  watch: {
    companyId(value) {
      if(value){
        this.getChanceList(value);
      }else {
        this.chance_id = '';
        this.chanceList = [];
      }
    },
  },
  created() {
    this.getChanceList(this.companyId);
  },
  mounted() {
      this.initData();
  },

  methods: {
    async getChanceList(company_id){
      if(!company_id){
        return;
      }
      this.chanceList = await this.$http('assetService.getChanceListByCompany',{company_id:company_id});
    },
    async getContractList(){
      this.contractList = await this.$http('assetService.getContractListByChance',{chance_id:this.chance_id});
    },
    async saveData(){
      if(!this.chance_id){
        this.$message.error('机会编号为空');
        return;
      }
      // if(!this.contract_no){
      //   this.$message.error('合同编号为空');
      //   return;
      // }
      if(!this.companyId){
        this.$message.error('公司为空');
        return;
      }
      let snInfo = this.$refs.after_sales_sn_general.formInfo;
      let check1 = this.checkSnInfoRequired('after_sales_sn_general', snInfo);
      if(!check1){
        return;
      }
      let productInfo = this.$refs.crm_asset_product_manage.formInfo;
      let productList = this.checkProductInfoRequired(productInfo);
      if(!productList){
        return;
      }
      let params = {
        company_id:this.companyId,
        chance_id:this.chance_id,
        contract_no:this.contract_no,
        remark:this.remark,
        operate:'add',
        sn_info:snInfo,
        product_info:productList,
      }
      await this.$http('assetService.addSnOperate', params).then(() => {
        this.$message.success("保存成功");
        this.$fn.closeWindow();
        this.$fn.search();
      })
    },

    async checkSnInfoRequired(formId,data){
      let json = await this.$store.dispatch('core/getFormDef',formId);
      let items = json?.items;
      let snNotRequired = false;
      if(data['asset_type'] === 'hardware'){
        snNotRequired = true;
      }
      for (let item of items) {
        if(item.required){
          if(item.data_key === 'serial_number' && snNotRequired){
            continue;
          }
          if(!data[item.data_key]){
            this.$message.error(item.label+'不能为空');
            return false;
          }
        }
      }
      return true;
    },
    checkProductInfoRequired(data){
      let dataList = data?.detail_list || [];
      let list = [];
      for (let item of dataList) {
        if(item.product_id && item.cnt){
         list.push(item);
        }
      }
      if(list.length === 0){
        this.$message.error('产品明细不能为空');
        return false;
      }
      return list;
    },

    initData(){
      if(this.isDisable){
        let data = this.parentData;
        let otherContent = JSON.parse(data.other_content);
        let snInfo = JSON.parse(data.sn_info_after);
        let productInfo = JSON.parse(data.product_info_after);

        this.chance_id = otherContent.chance_id;
        this.contract_no = otherContent.contract_no;
        this.remark = otherContent.remark;

        setTimeout(() => {
          this.$refs.after_sales_sn_general.mergeFormData(snInfo);
          let productData = {
            detail_list: productInfo,
          }
          this.$refs.crm_asset_product_manage.mergeFormData(productData);
        },2000);
      }
    }

  }
}
</script>

<style scoped>

</style>